import React, { useEffect, useState } from 'react';
import { addMonths } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DateTimePickerHandler({
  form_data,
  setFormData,
  Name = "input",
  Label = "",
  is_disabled = false
}) {
  const [selectedDateTime, setSelectedDateTime] = useState(form_data[Name] ? new Date(form_data[Name]) : new Date());

  useEffect(() => {
    if (form_data[Name]) {
      setSelectedDateTime(new Date(form_data[Name]));
    }
  }, [form_data, Name]);

  const handleChange = (date) => {
    setSelectedDateTime(date);
    setFormData(prev => ({
      ...prev,
      [Name]: date.toISOString()  // Save in ISO format like "2025-04-27T14:45:00Z"
    }));
  };

  return (
    <div className="form-group CustomDatepicker">
      {Label && <label className="form-label">{Label}</label>}
      <DatePicker
        selected={selectedDateTime}
        onChange={handleChange}
        showTimeSelect
        timeFormat="hh:mm aa"
        timeIntervals={15}
        dateFormat="MMMM d, yyyy h:mm aa"
        minDate={new Date()}
        maxDate={addMonths(new Date(), 5)}
        disabled={is_disabled}
        className="form-control"
        placeholderText={`Select ${Label}`}
        isClearable

        // selectsRange
        // inline
        // showDisabledMonthNavigation
        // icon={
        //   <svg
        //     xmlns="http://www.w3.org/2000/svg"
        //     width="1em"
        //     height="1em"
        //     viewBox="0 0 48 48"
        //   >
        //     <mask id="ipSApplication0">
        //       <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
        //         <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
        //         <path
        //           fill="#fff"
        //           d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
        //         ></path>
        //       </g>
        //     </mask>
        //     <path
        //       fill="currentColor"
        //       d="M0 0h48v48H0z"
        //       mask="url(#ipSApplication0)"
        //     ></path>
        //   </svg>
        // }

        // holidays={[
        //   { date: "2023-08-15", holidayName: "India's Independence Day" },
        //   { date: "2023-12-31", holidayName: "New Year's Eve" },
        //   { date: "2023-12-25", holidayName: "Christmas" },
        //   { date: "2024-01-01", holidayName: "New Year's Day" },
        //   { date: "2023-11-23", holidayName: "Thanksgiving Day" },
        //   { date: "2023-12-25", holidayName: "Fake holiday" },
        // ]}
        // showIcon
/>
    </div>
  );
}
